import React, { useState } from "react";

const ThinkyTTS = ({ text, style }) => {
  const [loading, setLoading] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);

  const speak = async () => {
    if (!text) return;
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_TTS_URL}/tts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text, style }), // pass style to backend
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      const url = `${process.env.REACT_APP_TTS_URL}${data.audio_url}`;
      setAudioUrl(url);

      const audio = new Audio(url);
      audio.play();
    } catch (err) {
      console.error("ThinkyTTS error:", err);
      alert("Failed to generate audio. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center w-full max-w-md">
      <button
        onClick={speak}
        disabled={loading || !text}
        className={`mb-4 w-full py-2 rounded-lg font-semibold transition-colors ${
          loading || !text
            ? "bg-gray-700 text-gray-300 cursor-not-allowed"
            : "bg-blue-600 hover:bg-blue-700 text-white"
        }`}
      >
        {loading ? "Thinking..." : "Speak"}
      </button>

      {audioUrl && (
        <div className="w-full text-center">
          <p className="mb-2">Audio ready:</p>
          <audio src={audioUrl} controls autoPlay className="w-full" />
        </div>
      )}
    </div>
  );
};

export default ThinkyTTS;
